module.exports = __webpack_public_path__ + "img/9.f2992bae.jpg";